import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import { Logout, Close, Warning } from "@mui/icons-material";

const AdminLogoutDialog = ({ open, onClose }) => {
  const handleConfirm = () => {
    onClose();

    // Clear storage (same as LogoutHelper)
    sessionStorage.clear();
    localStorage.removeItem("is_active");
    localStorage.removeItem("token");
    localStorage.removeItem("ots_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("is_register");
    localStorage.removeItem("user_email");
    localStorage.removeItem("name");
    localStorage.removeItem("admin_demo_mode");

    // Redirect to admin login
    window.location.href = "/admin-login";
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          minWidth: { xs: 300, sm: 400 },
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pb: 0, pr: 6 }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: "#9ca3af",
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", pt: 2 }}>
        <Avatar
          sx={{
            width: 80,
            height: 80,
            bgcolor: "#fef2f2",
            mx: "auto",
            mb: 2,
          }}
        >
          <Logout sx={{ fontSize: 40, color: "#ef4444" }} />
        </Avatar>

        <Typography variant="h5" sx={{ fontWeight: 700, color: "#1e293b", mb: 1 }}>
          Logout from Admin Panel?
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Are you sure you want to logout? You will need to login again to access the admin dashboard.
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            mt: 2,
            p: 1.5,
            bgcolor: "#fffbeb",
            borderRadius: 2,
            border: "1px solid #fcd34d",
          }}
        >
          <Warning sx={{ color: "#d97706", fontSize: 20 }} />
          <Typography variant="caption" sx={{ color: "#92400e" }}>
            Any unsaved changes will be lost
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 2, gap: 1 }}>
        <Button
          fullWidth
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "#e5e7eb",
            color: "#64748b",
            py: 1.2,
            borderRadius: 2,
            "&:hover": {
              borderColor: "#d1d5db",
              bgcolor: "#f9fafb",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          onClick={handleConfirm}
          variant="contained"
          startIcon={<Logout />}
          sx={{
            bgcolor: "#ef4444",
            py: 1.2,
            borderRadius: 2,
            "&:hover": {
              bgcolor: "#dc2626",
            },
          }}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminLogoutDialog;
